export default __webpack_public_path__ + "static/media/bell-red.0f4bcd72.svg";